var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: "Personal Settings",
      staticClass: "container-fluid mb-5 px-md-5 form-page",
      attrs: { id: "client-settings-container" },
    },
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("settings.personalSettings"),
          size: "col-10 col-md-7",
          "container-class": "justify-content-start",
        },
        scopedSlots: _vm._u([
          {
            key: "inlinebuttons",
            fn: function () {
              return [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-lg-inline-flex flex-row d-none justify-content-end",
                    attrs: { cols: "3" },
                  },
                  [
                    _vm.saving
                      ? _c("inline-loader")
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            attrs: { type: "button", disabled: !_vm.allowSave },
                            on: { click: _vm.startSaving },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.actions.saveChanges")) +
                                "\n        "
                            ),
                          ]
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "dropleft d-flex d-lg-none col-2 col-md-3 justify-content-end",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "grey-text text-darken-4 clickable d-xl-none",
                        attrs: { "data-toggle": "dropdown" },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("more_vert"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-menu" }, [
                      _c(
                        "div",
                        { staticClass: "dropdown-item clickable wide px-4" },
                        [
                          _vm.saving
                            ? _c("inline-loader")
                            : _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btn-sm",
                                  attrs: {
                                    type: "button",
                                    disabled: !_vm.allowSave,
                                  },
                                  on: { click: _vm.startSaving },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("global.actions.saveChanges")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "pb-4" },
        [
          _c("settings-navigation", {
            attrs: {
              tabs: _vm.tabs,
              "current-tab": _vm.currentTab,
              "settings-key": "settings",
            },
            on: { "tab-change": _vm.handleTabChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "10" } },
            [
              _c(_vm.currentTabComponent, {
                tag: "component",
                attrs: {
                  saving: _vm.saving,
                  "settings-type": _vm.settingsType,
                  "is-brokerage": false,
                },
                on: {
                  "finish-saving": _vm.finishSaving,
                  "allow-save": _vm.handleAllowSave,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }